// eslint-disable-next-line
import { h, render } from 'preact';
import App from './components/App';

function initMiniCartReminder() {
    const appContainer = document.createElement('div');
    appContainer.id = 'minicart-reminder-widget-container';

    document.body.appendChild(appContainer);

    render(<App />, appContainer);
}

if (document.readyState !== 'loading') {
    initMiniCartReminder();
} else {
    document.addEventListener('DOMContentLoaded', initMiniCartReminder);
}
